package fr.manyverse.app.presentation.components.premade

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.ItemCategory
import fr.manyverse.app.presentation.components.inventory.InventoryItemImage
import fr.manyverse.app.presentation.components.inventory.label

/**
 * Ligne d'affichage d'un objet d'inventaire de pré-tiré : vignette + nom + quantité (si consommable)
 * + type entre parenthèses. Le slot [trailing] reçoit les contrôles spécifiques au contexte
 * (case à cocher pour l'import, boutons éditer/supprimer pour l'édition, rien pour la consultation).
 */
@Composable
fun PreMadeInventoryRow(
    name: String,
    category: ItemCategory,
    quantity: Int,
    signedImageUrl: String?,
    modifier: Modifier = Modifier,
    localImageBytes: ByteArray? = null,
    trailing: (@Composable RowScope.() -> Unit)? = null,
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        InventoryItemImage(
            signedImageUrl = signedImageUrl,
            itemName = name,
            category = category,
            modifier = Modifier.size(48.dp),
            localImageBytes = localImageBytes,
            shape = RoundedCornerShape(12.dp)
        )
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = name,
                style = MaterialTheme.typography.bodyLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Row(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                if (category == ItemCategory.CONSUMABLE) {
                    Text(
                        text = "×$quantity",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                Text(
                    text = "(${category.label()})",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
        }
        trailing?.let {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                content = it
            )
        }
    }
}
